export default __webpack_public_path__ + "fonts/dotted-delivery-PC.svg";